import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AddPost, GetPostById } from '../services/postservice';
import { GetAllCategory } from '../services/categoryservice';
import { GetAllUser } from '../services/userservice';
import { GetAllMedia } from '../services/mediaservice';
import { GetAllTags } from '../services/tagservice';
import { AddPostTags, GetAllPostTags, DeletePostTag } from '../services/posttagservice';
import PostTags from './posttags';
import RichTextEditor, { PreviewContent } from '../components/RichTextEditor';

import '../code.css';
import slugify from 'slugify';

function PostNew({ placeholder }) {
    const [pk, setPk] = useState(0);
    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState('');

    const [readTime, setReadTime] = useState("");
    const [views, setViews] = useState("0");
    const [desc, setDesc] = useState("");
    const [category, setCategory] = useState("");
    const [addedby, setAddedby] = useState("");
    const [categoryOption, setCategoryOption] = useState([]);
    const [userOption, setUserOption] = useState([]);
    const [mediaOption, setMediaOption] = useState([]);
    const [mediapk, setMediaPk] = useState(0);
    const [mediaPath, setMediaPath] = useState("");
    const [ispublished, setIsPublished] = useState();
    const [editPost, setEditPost] = useState(false);
    const [metatitle, setMetaTitle] = useState('');
    const [metadesc, setMetaDesc] = useState('');
    const [metakeywords, setMetaKeywords] = useState('');

    let navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const id = queryParams.get('pk') || null;

    useEffect(() => {
        fillCategoryData();
        fillUserData();
        fillMediaData();
        
        if (id != null) {
            fillData(id);
            setPk(id);
            setEditPost(true);
        }

    }, []);

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        setSlug(slugify(event.target.value, { lower: true, strict: true }));
    };

   
    const fillData = async (postPk) => {
        try {
            const postDetail = await GetPostById(postPk);
            const jsonData = JSON.parse(postDetail);
            setTitle(jsonData.title);
            setDesc(jsonData.description);
            setCategory(jsonData.categorypk);
            setSlug(jsonData.paramlink);
            setReadTime(jsonData.readtime);
            setViews(jsonData.views);
            setAddedby(jsonData.addedbyid);
            setMediaPk(jsonData.mediapk);
            setIsPublished(jsonData.ispublished);
            setMediaPath(jsonData.mediapath);
			setMetaTitle(jsonData.metatitle);
            setMetaDesc(jsonData.metadesc);
            setMetaKeywords(jsonData.metakeywords); 
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const fillCategoryData = async () => {
        try {
            const catList = await GetAllCategory();
            const jsonCatList = JSON.parse(catList);
            setCategoryOption(jsonCatList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }
    const fillUserData = async () => {
        try {
            const userList = await GetAllUser();
            const jsonUserList = JSON.parse(userList);
            setUserOption(jsonUserList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }
    const fillMediaData = async () => {
        try {
            const dataList = await GetAllMedia();
            const jsonDataList = JSON.parse(dataList);
            setMediaOption(jsonDataList);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const SavePost = (isPublished) => {
        const postBody = JSON.stringify({
            pk: pk,
            title: title,
            description: desc,
            paramlink: slug,
            categorypk: category,
            readtime: readTime,
            views: views,
            addedbyid: addedby,
            mediapk: mediapk,
            ispublished: isPublished,
            Metatitle: metatitle,
            Metadesc: metadesc,
            Metakeywords: metakeywords
        });

        AddPost(postBody);
        if (pk == 0)
            navigate('/post', { state: { successMessage: 'New post record added' } });
        else
            navigate('/post', { state: { successMessage: 'Post record updated' } });
    };

    const handleMediaChange = async (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const propertyValue = selectedOption.getAttribute('data-path');

        setMediaPk(event.target.value);
        setMediaPath("http://api.databeautifier.com/blogimages/" + propertyValue);
    }

    const handleSave = async (isPublished) => {
        setIsPublished(isPublished);
        SavePost(isPublished);
    }

    const handlePublish = async (isPublished) => {
        setIsPublished(isPublished);
        SavePost(isPublished);
    }

    const handleCancel = async () => {
        navigate('/post/');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new post</h4>
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtTitle">Title</label>
                                    <input type="text" class="form-control" id="txtTitle" onChange={handleTitleChange} placeholder="Title" value={title} />
                                    <div className='slug'>{slug}</div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="txtTitle">Category</label>
                                            <select class="form-control dropdown" onChange={(e) => setCategory(e.target.value)} value={category}>
                                                <option value="">Select Category</option>
                                                {categoryOption && categoryOption.map((option) => (
                                                    <option value={option.pk}>{option.title}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="txtTitle">Author</label>
                                            <select class="form-control dropdown" onChange={(e) => setAddedby(e.target.value)} value={addedby}>
                                                <option value="">Select Author</option>
                                                {userOption && userOption.map((option) => (
                                                    <option value={option.pk}>{option.fullname}</option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="txtTitle">Read Time</label>
                                            <input type="text" class="form-control" id="txtReadTime" onChange={(e) => setReadTime(e.target.value)} placeholder="Read Time" value={readTime} />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="txtTitle">Views</label>
                                            <input type="text" class="form-control" id="txtViews" onChange={(e) => setViews(e.target.value)} placeholder="Views" value={views} disabled />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtMedia">Media</label>
                                            <select class="form-control dropdown" onChange={handleMediaChange} value={mediapk}>
                                                <option value="">Select Media</option>
                                                {mediaOption && mediaOption.map((option) => (
                                                    <option value={option.pk} data-path={option.filename}>{option.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <img src={mediaPath} style={{ width: 300, height: 250 }} />
                                    </div>
                                </div>
								<div class="row">
                                    <div class="form-group">
                                    <label for="txtMetaTitle">Meta Title</label>
                                    <input type="text" class="form-control" id="txtMetaTitle" onChange={(e) => setMetaTitle(e.target.value)} placeholder="Meta Title" value={metatitle}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtMetaDesc">Meta Desc</label>
                                    <input type="text" class="form-control" id="txtMetaDesc" onChange={(e) => setMetaDesc(e.target.value)} placeholder="Meta Description" value={metadesc}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtMetaKeywords">Meta Keywords</label>
                                    <input type="text" class="form-control" id="txtMetaKeywords" onChange={(e) => setMetaKeywords(e.target.value)} placeholder="Meta Keywords" value={metakeywords}/>
                                </div>
                                </div>
                                <div class="form-group"> </div>
                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave(false)}>Save Draft</button>
                                <button type="button" class="btn btn-primary me-2" onClick={() => handlePublish(true)}>Publish</button>
                                <button class="btn btn-light" onClick={() => handleCancel()}>Cancel</button>
                                <div className='m-t-20'>
                                    <h3>Tags</h3>
                                </div>                    
                                {editPost ? (
                                    <PostTags postpk={id} />
                                ) : (
                                    <div></div>
                                )
                                }
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label style={{ marginBottom: '6px' }}>Description</label>
                                    <RichTextEditor
                                        value={desc}
                                        onChange={(val) => setDesc(val)}
                                        placeholder="Start typing..."
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div style={{ padding: '5px 0 10px 0' }}>
                                <span style={{ fontSize: '12px', fontWeight: '600', color: '#aaa', letterSpacing: '1px', textTransform: 'uppercase' }}>Preview</span>
                            </div>
                            <hr style={{ marginTop: 0 }} />
                            <PreviewContent html={desc} className='dropcap-paragraph' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PostNew;